import React from 'react';
import { components } from '@kurtosys/ksys-app-components';
import { ISourceApplication } from '@kurtosys/types/eventBus/ISourceApplication.js';
import Box from '@mui/material/Box/Box.js';
import Grid from '@mui/material/Unstable_Grid2/Grid2.js';

import { AppStore } from '../App/stores/AppStore.js';
import { useStores } from '../hooks/useStores.js';
import { TabsStore } from '../Tabs/stores/TabsStore.js';

import { IContentProps } from './models/IContentProps.js';

const ApplicationEmbed = components.base.ApplicationEmbed.ApplicationEmbed;

export const Content: React.FC<IContentProps> = ({ currentGrid, parentId, tabKey }) => {
	const { hasDataMapKey, serviceUrl, isConditionValid, appLevelGuid, appHasData, intersectionRender } =
		useStores<AppStore>('appStore');
	const { tabInputs } = useStores<TabsStore>('tabsStore');
	return (
		<>
			{currentGrid.map(({ conditional, options, grid, ...gridItem }, gridIndex) => {
				const { noDataOptions, ...gridOptions } = options || {};
				if (isConditionValid(conditional)) {
					const hasDataKey = gridItem.applicationEmbed
						? hasDataMapKey(gridItem.applicationEmbed as ISourceApplication)
						: '';
					const hasData = appHasData.get(hasDataKey);
					const showGridItem = noDataOptions?.hideLevel === 'gridItem' ? hasData : true;
					const showApplication = noDataOptions?.hideLevel === 'application' ? hasData : true;
					let id: string;
					if (!parentId) {
						id = `${appLevelGuid}-${gridIndex}`;
					} else {
						id = `${parentId}-${gridIndex}`;
					}

					return (
						<React.Fragment key={`content-${tabKey}-${id}`}>
							{showGridItem && (
								<Grid xs={12} {...gridOptions}>
									{showApplication && !grid && (
										<Box
											sx={{
												padding: 0,
												backgroundColor: 'transparent',
											}}
										>
											<ApplicationEmbed
												forceScriptInject
												className="tabs-application-embed"
												hostname={serviceUrl}
												inputs={tabInputs}
												render={intersectionRender}
												{...gridItem.applicationEmbed}
											/>
										</Box>
									)}
									{grid && <Content currentGrid={grid} parentId={id} />}
								</Grid>
							)}
						</React.Fragment>
					);
				}
			})}
		</>
	);
};
